import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const SolutionSection = () => {
  const { t } = useLanguage();

  const features = [
    {
      icon: "UserX",
      title: t('solution.completeAnonymity'),
      description: t('solution.completeAnonymityDesc')
    },
    {
      icon: "Target",
      title: t('solution.curatedOpportunities'),
      description: t('solution.curatedOpportunitiesDesc')
    },
    {
      icon: "Database",
      title: t('solution.smartMatching'),
      description: t('solution.smartMatchingDesc')
    },
    {
      icon: "Lock",
      title: t('solution.controlReveals'),
      description: t('solution.controlRevealsDesc')
    }
  ];

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-gradient-to-br from-gray-50 to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/60 backdrop-blur-xl border border-white/20 shadow-lg rounded-full mb-4 md:mb-6">
            <Icon name="CheckCircle2" size={20} color="#0025cc" />
            <span className="text-sm md:text-base font-medium text-[#0025cc]">{t('solution.badge')}</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111827] mb-4">
            {t('solution.title')}
          </h2>
          <p className="text-base md:text-lg text-[#6B7280] max-w-2xl mx-auto">
            {t('solution.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-12">
          {features?.map((feature, index) => (
            <div 
              key={index}
              className="flex gap-4 md:gap-6 p-6 md:p-8 rounded-3xl bg-white/40 backdrop-blur-xl border border-white/20 shadow-xl hover:shadow-2xl hover:bg-white/50 transition-all duration-300"
              style={{
                background: 'linear-gradient(135deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.2) 100%)'
              }}
            >
              <div className="flex-shrink-0">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-gradient-to-br from-[#0025cc] to-[#0025cc] flex items-center justify-center shadow-lg">
                  <Icon name={feature?.icon} size={24} color="#FFFFFF" />
                </div>
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-semibold text-[#111827] mb-2 md:mb-3">
                  {feature?.title}
                </h3>
                <p className="text-sm md:text-base text-[#6B7280] leading-relaxed">
                  {feature?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;